var Backbone = require('backbone'),
    moment = require('moment');

/*
* Model representing a DocumentLockStatus response from the server.
* Sent as response body for document lock web services (status, lock, unlock),
* as well as in the response body of 409 errors in failed transactions due to
* the document being locked by another user.
* Useful for showing a consistent error message due to documents being locked by another user.
* */

module.exports = Backbone.Model.extend({

    defaults: {
        "locked": null,
        "userLockId": null,
        "userLockName": null,
        "userLockDescription": null,
        "userLockFriendlyName": null,
        "lockedByCurrentUser": null,
        "lockedSince": null,
        "docId": null,
        "success": null // flag indicating if call to lock/unlock was successful
    },

    isLocked: function() {
        return this.get('locked');
    },

    isLockedByOtherUser: function() {
        return this.isLocked() && !this.get('lockedByCurrentUser');
    },

    /*
    * Return the default error message displayed in alert dialogs.
    * */
    getDefaultErrorMessage: function() {
        return 'Document locked by ' + this.getUserLockFriendlyName() +
            ' since ' + moment.convertDBTimeToLocalTime( this.getLockedSince() ); //TODO: time from server appears off

    },

    getSuccess: function() {
        return this.get('success');
    },

    getUserLockFriendlyName: function() {
        return this.get('userLockFriendlyName');
    },

    getLockedSince: function() {
        return this.get('lockedSince');
    },

    getDocId: function() {
        return this.get('docId');
    }


});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/FV/documentLockStatus.js
 ** module id = 405
 ** module chunks = 0
 **/